const REMAINING_CODES_PARAM = 'remaining_codes';

export const appendRemainingCodesParam = (url: string, remaining?: number): string => {
  if (remaining === undefined || remaining === null) return url;

  const [pathAndQuery, hash = ''] = url.split('#');
  const separator = pathAndQuery.includes('?') ? '&' : '?';
  const withParam = `${pathAndQuery}${separator}${REMAINING_CODES_PARAM}=${encodeURIComponent(
    String(remaining),
  )}`;

  return hash ? `${withParam}#${hash}` : withParam;
};
